import Cookies from 'cookies-js';

// Cookie set at the edge (Akamai EdgeWorker) holding the Optimizely visitor id
const OPTIMIZELY_VISITOR_ID_COOKIE = 'x-lc-website-optimizely-visitor-id';

// Heap v4 stores its session IDs in a `_hp2_id.{appId}` cookie, where `{appId}`
// is the Heap account loaded on the page (`window._heapid`, set in _document.jsx)
const HEAP_ID_COOKIE_PREFIX = '_hp2_id.';

// Builds the 5 additional Heap event attributes:
//   - the Optimizely visitor id (set at the edge)
//   - userId, pageviewId, sessionId and identity, read from the Heap cookie
export function getHeapEventAttributes() {
  const attributes = {};

  const optimizelyVisitorId = Cookies.get(OPTIMIZELY_VISITOR_ID_COOKIE);
  if (optimizelyVisitorId) {
    attributes.optimizelyVisitorId = optimizelyVisitorId;
  }

  // Target the cookie for the Heap account loaded for the current env on the page
  // so the ids we send belong to the same session, even if cookies for other Heap
  // accounts (e.g. from local/demo/stage) are present.
  const heapAppId =
    // eslint-disable-next-line no-underscore-dangle
    typeof window !== 'undefined' && (window._heapid || window.heap?.appid);
  const heapCookie =
    heapAppId && Cookies.get(`${HEAP_ID_COOKIE_PREFIX}${heapAppId}`);
  if (heapCookie) {
    try {
      const { userId, pageviewId, sessionId, identity } =
        JSON.parse(heapCookie);
      attributes.heapUserId = userId;
      attributes.heapPageviewId = pageviewId;
      attributes.heapSessionId = sessionId;
      attributes.heapIdentity = identity;
    } catch (e) {
      // malformed cookie should not break event tracking
    }
  }

  return attributes;
}

// Attaches the shared attributes to every Heap event (custom and autocaptured)
// via `addEventProperties`. Call once on app mount. Registers whatever is
// available.
export function registerHeapEventProperties() {
  if (typeof window === 'undefined' || !window.heap?.addEventProperties) {
    return;
  }

  const attributes = getHeapEventAttributes();
  if (Object.keys(attributes).length > 0) {
    window.heap.addEventProperties(attributes);
  }
}

export default function trackHeapEvent(
  properties,
  eventName = undefined,
  experiments = undefined
) {
  if (window.heap?.track) {
    const nameEvent = !eventName ? 'CMS_Unification' : eventName;
    window.heap.track(nameEvent, properties);
    if (experiments) {
      window.heap.track('LC_Website_Optimizely_Exp', experiments);
      window.heap.addUserProperties(experiments);
    }
  }
}
